import { api } from "../../api";

const createQueryParams = (params, isAdditionalFilters) => {
    if (!params || typeof params !== "object") return "";

    const appliedFilters = Object.keys(params)
        .map((key) => {
            const value = params[key];
            if (value === undefined || value === null || value === "")
                return "";
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
        .filter(Boolean)
        .join("&");

    if (!appliedFilters) return "";
    return isAdditionalFilters ? `?${appliedFilters}` : `&${appliedFilters}`;
};

export const salesApi = api.injectEndpoints({
    endpoints: (build) => ({
        getActiveTiers: build.query({
            query: ({ include_clients }) =>
                `/sales/active-tiers/?include_clients=${include_clients}`,
        }),
        getAccountFilter: build.query({
            query: () => `/sales/account-filter/`,
        }),
        getClientDetail: build.query({
            query: (params) => {
                const appliedFilters = createQueryParams(params);
                return `/sales/client-details/?${appliedFilters}`;
            },
        }),
        getClientAccounts: build.query({
            query: (params) => {
                const pageParams = params.page ? `&page=${params.page}` : "";
                const pageSizeParams = params.pageSize
                    ? `&page_size=${params.pageSize}`
                    : "";
                const appliedFilters = createQueryParams(params.appliedFilters);
                return `/sales/accounts-client/?${pageParams}${pageSizeParams}${appliedFilters}`;
            },
        }),
        getBusinessTrends: build.query({
            query: (params) => {
                const appliedFilters = createQueryParams(params.appliedFilters);
                return `/sales/business-trend/?start_date=${params.startDate}&end_date=${params.endDate}&&client_id=${params.appliedFilters.client_id}`;
            },
        }),
        getInteractionTrends: build.query({
            query: ({ id, start_date, end_date }) =>
                `/sales/interactions/?client_id=${id}&start_date=${start_date}&end_date=${end_date}`,
        }),
        getClientFinancials: build.query({
            query: (params) => {
                return `/sales/client-financials/?date=${params.endDate}`;
            },
        }),
        getClientVote: build.query({
            query: (params) => {
                const appliedFilters = createQueryParams(params.appliedFilters);
                const pageParams = params.page ? `&page=${params.page}` : "";
                const pageSizeParams = params.pageSize
                    ? `&page_size=${params.pageSize}`
                    : "";
                return `/sales/client-vote/?date=${params.endDate}${appliedFilters}${pageParams}${pageSizeParams}`;
            },
        }),
        getClientTouchPoints: build.query({
            query: (params) => {
                const appliedFilters = createQueryParams(params.appliedFilters);
                const pageParams = params.page ? `&page=${params.page}` : "";
                const pageSizeParams = params.pageSize
                    ? `&page_size=${params.pageSize}`
                    : "";
                return `/sales/client-touchpoints/?start_date=${params.startDate}&end_date=${params.endDate}${pageParams}${pageSizeParams}${appliedFilters}`;
            },
        }),
        getClientTrends: build.query({
            query: (params) => {
                const appliedFilters = createQueryParams(params.appliedFilters);
                return `/sales/client-trends/?start_date=${params.startDate}&end_date=${params.endDate}${appliedFilters}`;
            },
        }),
        getUserList: build.query({
            query: () => `/sales/user-list/`,
        }),
        getTodoItems: build.query({
            query: (params) => {
                const appliedFilters = createQueryParams(params);
                return `/sales/todo/?${appliedFilters}`;
            },
            providesTags: ["Todo"],
        }),
        createTodoItem: build.mutation({
            query: ({ data }) => ({
                url: `/sales/todo/`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Todo"],
        }),
        updateTodoItem: build.mutation({
            query: ({ data }) => ({
                url: `/sales/todo/${data.id}/`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["Todo"],
        }),
        deleteTodoItem: build.mutation({
            query: ({ id }) => ({
                url: `/sales/todo/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["Todo"],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetActiveTiersQuery,
    useGetClientAccountsQuery,
    useGetAccountFilterQuery,
    useGetClientFinancialsQuery,
    useGetClientVoteQuery,
    useGetClientTouchPointsQuery,
    useGetClientTrendsQuery,
    useGetBusinessTrendsQuery,
    useGetInteractionTrendsQuery,
    useGetClientDetailQuery,
    useGetUserListQuery,
    useGetTodoItemsQuery,
    useCreateTodoItemMutation,
    useUpdateTodoItemMutation,
    useDeleteTodoItemMutation,
} = salesApi;
